import { useEffect } from 'react';
import FilterBar, { Filters } from './FilterBar.js';
import { useState } from 'react';
import { useRegistry } from '../../hooks/useRegistry.js';

export default function CatalogPane() {
  const [f, setFilters] = useState<Filters>({});
  const { items, refetch } = useRegistry(f);

  useEffect(() => {
    // const unsub = window.HiveEventBus?.subscribe?.('registry.updated', refetch);
    // return () => unsub?.();
  }, [refetch]);

  return (
    <section className="p-6">
      <h1 className="text-2xl font-semibold mb-2">Catalog</h1>
      <FilterBar onChange={setFilters} />
      <div className="grid gap-4 mt-4 md:grid-cols-2 lg:grid-cols-3">
        {items.map(i => (
          <div key={`${i.scope}-${i.name}-${i.version || 'latest'}`} 
               className="border rounded-lg p-4 hover:shadow-md transition-shadow">
            <h3 className="font-semibold">{i.name}</h3>
            <div className="flex gap-1 flex-wrap text-[10px] mt-2">
              <span className={`badge badge-${i.type}`}>{i.type}</span>
              <span className="badge bg-neutral-500/10">{i.scope}</span>
              {i.tags?.slice(0,3).map(t=>(
                <span key={t} className="badge bg-neutral-800/10">{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
